import PersonnelBox from "./PersonnelBox";
import shipImage from "../../asset/images/keyPersonnel/keyPersonnel.jpg";

const PersonnelBoxes = ({ personnel }) => {
  return (
    <section className="key-personnel-content">
      <div className="content-controller mm-width">
        <div className="main-col col-left">
          <div className="img-place">
            <img src={shipImage} alt="Key Personnel" />
          </div>
          <PersonnelBox {...personnel[0]} />
        </div>
        <div className="main-col col-right">
          {personnel.slice(1).map((p, index) => (
            <PersonnelBox key={index} {...p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PersonnelBoxes;
